import { MapPin, AlertTriangle } from "lucide-react";
import MiniMap from "@/components/MiniMap";
import { useI18n } from "@/context/I18nContext";

export function GpsFields({ form, set, outOfBounds, useMyLocation, mapCenter }) {
  const { t } = useI18n();
  return (
    <div className="col-span-2 border-t border-slate-700 pt-3 mt-1">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-xs text-cyan-400 font-semibold uppercase tracking-wide">{t("Współrzędne GPS")}</span>
        <button type="button" onClick={useMyLocation} data-testid="use-my-location"
          className="text-xs flex items-center gap-1 text-slate-300 hover:text-cyan-400">
          <MapPin size={13} /> {t("Moja lokalizacja")}
        </button>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="text-xs text-slate-400 mb-1 block">{t("Szerokość (lat)")}</label>
          <input type="number" step="any" value={form.lat} onChange={(e) => set("lat", e.target.value)}
            data-testid="field-lat" placeholder="np. 52.229700"
            className={`w-full bg-slate-900 border rounded px-2 py-2 text-sm font-mono outline-none focus:ring-1 ${outOfBounds ? "border-yellow-500 focus:ring-yellow-500" : "border-slate-700 focus:ring-cyan-500"}`} />
        </div>
        <div>
          <label className="text-xs text-slate-400 mb-1 block">{t("Długość (lng)")}</label>
          <input type="number" step="any" value={form.lng} onChange={(e) => set("lng", e.target.value)}
            data-testid="field-lng" placeholder="np. 21.012200"
            className={`w-full bg-slate-900 border rounded px-2 py-2 text-sm font-mono outline-none focus:ring-1 ${outOfBounds ? "border-yellow-500 focus:ring-yellow-500" : "border-slate-700 focus:ring-cyan-500"}`} />
        </div>
      </div>
      {outOfBounds ? (
        <div className="mt-1.5 flex items-start gap-1.5 text-[11px] text-yellow-400" data-testid="gps-warning">
          <AlertTriangle size={13} className="shrink-0 mt-0.5" />
          <span>Uwaga: punkt leży poza obszarem Polski (49–55°N, 14–24°E). Sprawdź, czy współrzędne są poprawne.</span>
        </div>
      ) : (
        <p className="text-[11px] text-slate-500 mt-1.5">
          Kliknij na mini-mapie poniżej, wpisz współrzędne ręcznie lub pobierz z GPS.
        </p>
      )}
      <div className="mt-2">
        <MiniMap lat={form.lat} lng={form.lng} defaultCenter={mapCenter}
          onPick={(la, ln) => { set("lat", Number(la.toFixed(4))); set("lng", Number(ln.toFixed(4))); }} />
      </div>
    </div>
  );
}
